module.exports = __webpack_public_path__ + "static/media/Contact_Arrow.ac5aa373.svg";